module.exports = __webpack_public_path__ + "static/drumster-caseimg-min-a51163726c7bddd56ea965c8c32ba62b.webp";